import { useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { api } from '@astro/api'
import PageLayout from '../components/layout/PageLayout'
import FloatingFabs from '@astro/floating-fabs'
import AstrologerProfileHeroSection from '../components/sections/astrologerDetails/AstrologerProfileHeroSection'
import AstrologerAboutSection from '../components/sections/astrologerDetails/AstrologerAboutSection'
import AstrologerOfferingsSection from '../components/sections/astrologerDetails/AstrologerOfferingsSection'
import AstrologerReviewsSection from '../components/sections/astrologerDetails/AstrologerReviewsSection'
import AstrologerFaqSection from '../components/sections/astrologerDetails/AstrologerFaqSection'
import AstrologerBookingSidebar from '../components/sections/astrologerDetails/AstrologerBookingSidebar'
import AstrologerDetailsSkeleton from '../components/sections/astrologerDetails/AstrologerDetailsSkeleton'
import SimilarAstrologersSection from '../components/sections/astrologerDetails/SimilarAstrologersSection'
import { decorateAstrologerDetail, unwrapAstrologerRecord } from '../components/sections/astrologerDetails/astrologerDetailsData'

export default function AstrologerDetailsPage() {
  const { id } = useParams()

  const { data, isPending, isError, refetch } = useQuery({
    queryKey: ['astrologer', id],
    queryFn: () => api.astrologers.get(id),
    enabled: Boolean(id),
  })

  const record = data ? unwrapAstrologerRecord(data) : null
  const astro = record ? decorateAstrologerDetail(record) : null

  return (
    <PageLayout className="bg-[#403c3d]/5 text-[#151b21] antialiased min-h-screen flex flex-col">
      <main className="grow pt-28 lg:pt-32">
        {isPending ? (
          <AstrologerDetailsSkeleton />
        ) : isError || !astro ? (
          <div className="max-w-350 mx-auto px-4 sm:px-6 lg:px-12 py-24 text-center">
            <div className="text-5xl mb-4 opacity-40">🛰️</div>
            <p className="font-cinzel text-lg font-bold mb-1 text-[#1C140A]">Couldn&rsquo;t load this astrologer</p>
            <p className="text-sm mb-5 text-[#8B7355]">The profile may no longer be available, or something went wrong.</p>
            <button
              type="button"
              onClick={() => refetch()}
              className="inline-flex items-center gap-2 text-[10px] font-bold uppercase tracking-widest px-6 py-3 rounded-full border transition-colors"
              style={{ borderColor: 'rgba(200,146,42,.35)', color: '#C8922A', background: 'rgba(200,146,42,.06)' }}
            >
              Retry
            </button>
          </div>
        ) : (
          <>
            <AstrologerProfileHeroSection astro={astro} />
            <section className="relative max-w-350 mx-auto px-4 sm:px-6 lg:px-12 pb-16">
              <div className="grid gap-8 lg:grid-cols-[1fr_360px] items-start">
                <div className="space-y-8">
                  <AstrologerAboutSection astro={astro} />
                  <AstrologerOfferingsSection astro={astro} />
                  <AstrologerReviewsSection astro={astro} />
                  <AstrologerFaqSection />
                </div>
                <AstrologerBookingSidebar astro={astro} />
              </div>
            </section>
            <SimilarAstrologersSection excludeId={astro.id} />
          </>
        )}
      </main>
      <FloatingFabs />
    </PageLayout>
  )
}
